import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import React from 'react';

const Container = styled('div')({
    height: '100%',
    width: '100%',
    padding: '20px'
});

const Component = () => (
    <Container>
        <LinearProgress/>
    </Container>
);

export default Component;
